import React from 'react';

const AudioOnMobileMessage = () => {
  return (
    <div className="QuestionElement--mobileViewing">
      <span className="fw-b">
        {t('questions.question.media_recording.note')}:{' '}
      </span>
      <span>{t('questions.question.media_recording.mobile_message')} </span>
      <span className="fs-i">
        {t('questions.question.media_recording.audio_only')}{' '}
      </span>
      {t('questions.question.media_recording.must_upload_video')}
    </div>
  );
};

export default AudioOnMobileMessage;
